import Backbone from 'backbone';
import ActiveIndicatorEnum from 'utils/device/ActiveIndicatorEnum';

export default Backbone.Model.extend({
    backend: 'gcapi',

    urlRoot: '/device-service/deviceservice/device-info/',

    idAttribute: 'deviceId',

    save: function(key, value, options) {
        if (this.hasChanged('viewed')) {
            this.urlRoot = '/device-service/deviceservice/device-info/device';
        } else {
            this.urlRoot = '/device-service/deviceservice/device-info/';
        }
        return Backbone.Model.prototype.save.call(this, key, value, options);
    },

    isVivoki: function() {
        return this.get('applicationKey') == 'vivoki';
    },

    // This function is used before setting AAT or PAT to make sure the device isn't being used by another user
    isInUseByAnotherUser: function() {
        return this.get('otherAssociation') && this.get('activeInd') !== ActiveIndicatorEnum.ACTIVE;
    },

    hasExpressConnection() {
        return this.get('applicationKey') !== 'HRMDualAdvanced';
    }
});
